export default "__VITE_ASSET__C4Dts3g2__"